import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.k6w_1 = partyId;
        this.l6w_1 = playerId;
        this.m6w_1 = name;
        this.n6w_1 = email;
        this.o6w_1 = badge;
        this.p6w_1 = callSignAdjective;
        this.q6w_1 = callSignNoun;
        this.r6w_1 = imageURL;
        this.s6w_1 = avatarType;
        this.t6w_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.k6w_1.toString() + ', playerId=' + this.l6w_1.toString() + ', name=' + this.m6w_1 + ', email=' + this.n6w_1 + ', badge=' + this.o6w_1.toString() + ', callSignAdjective=' + this.p6w_1 + ', callSignNoun=' + this.q6w_1 + ', imageURL=' + toString(this.r6w_1) + ', avatarType=' + toString(this.s6w_1) + ', unvalidatedEmails=' + toString(this.t6w_1) + ')';
      }
      hashCode() {
        var result = this.k6w_1.hashCode();
        result = imul(result, 31) + this.l6w_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.m6w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n6w_1) | 0;
        result = imul(result, 31) + this.o6w_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.p6w_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q6w_1) | 0;
        result = imul(result, 31) + hashCode(this.r6w_1) | 0;
        result = imul(result, 31) + hashCode(this.s6w_1) | 0;
        result = imul(result, 31) + hashCode(this.t6w_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.k6w_1.equals(other.k6w_1))
          return false;
        if (!this.l6w_1.equals(other.l6w_1))
          return false;
        if (!(this.m6w_1 === other.m6w_1))
          return false;
        if (!(this.n6w_1 === other.n6w_1))
          return false;
        if (!this.o6w_1.equals(other.o6w_1))
          return false;
        if (!(this.p6w_1 === other.p6w_1))
          return false;
        if (!(this.q6w_1 === other.q6w_1))
          return false;
        if (!equals(this.r6w_1, other.r6w_1))
          return false;
        if (!equals(this.s6w_1, other.s6w_1))
          return false;
        if (!equals(this.t6w_1, other.t6w_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
